import request from '../../request';
import SkylightClient from '../shared/SkylightClient';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { getClasseParam } from '../../../utils/reading/tableUtils';
import { BASE_URLS, PARAM } from '../../../constants/reading/ApiConstants';
import { DIBELS8_APPLICATION_SID } from '../../../constants/reading/CommonConstants';

const { BASE_URL, STUDENT_RESULTS_URL } = BASE_URLS;
const { APPLICATION_SID, ETERNAL_STUDENT_SID, YEAR } = PARAM;

class D8SkylightClient extends SkylightClient {
    static getR3DResults = (
        studentIds,
        district,
        school,
        classe,
        applicationSid = DIBELS8_APPLICATION_SID,
    ) => super.getR3DResults(BASE_URL, applicationSid, studentIds, district, school, classe);

    static getProbeDetails = (enrollmentInfo, assessment, result) => {
        const { classe, school, district, burstGroupUid } = enrollmentInfo;
        const { period, schoolYear, studentId, measure, resultId, grade, resultGroupId } = result;
        const urlParamsDetails = {
            classe: getClasseParam(classe, burstGroupUid),
            school,
            district,
            assessment,
            period,
            year: schoolYear,
            studentSid: studentId,
            measure,
            resultId,
            gradeId: grade,
            resultGroup: resultGroupId,
        };

        return super.getProbeDetails({ baseUrl: BASE_URL, ...urlParamsDetails });
    };

    static getBurstResultsForYear = (
        studentId,
        district,
        school,
        classe,
        year,
        applicationSid = DIBELS8_APPLICATION_SID,
    ) => {
        const urlWithQueryParams = constructUrlObject(STUDENT_RESULTS_URL, {
            [ETERNAL_STUDENT_SID]: studentId,
            district,
            school,
            classe,
            [YEAR]: year,
            [APPLICATION_SID]: applicationSid,
        });
        return request.get(urlWithQueryParams);
    };
}

export default D8SkylightClient;
